/**
 * Header section of dashboard page
 */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Button } from 'wix-style-react'

import HeaderLayout from '../shared/HeaderLayout'
import ProfileMenu from './ProfileMenu'
import history from '../history'
import Logo from 'components/Logo'
import { DARK_GRAY, LIGHT_GRAY } from '../styles'
import HelpIcon from 'react-icons/lib/fa/question'

const NavigationItem = styled.div`
  font-weight: 200;
  font-size: 95%;
  color: ${DARK_GRAY};
  padding: 0 20px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: ${LIGHT_GRAY};
  }
`
const ExternalUrl = styled.a`
`

class DashboardHeader extends Component {

  goToDashboard = () => {
    history.push('/dashboard')
  }

  render () {
    return (
      <HeaderLayout
        leftNav={
          <div>
            <Logo onClick={this.goToDashboard} />
          </div>
        }
        rightNav={[
          <NavigationItem key='NavigationItem'>
            <ExternalUrl href='http://help.whimm.co/en' target='_blank'>
              <Button
                height='medium'
                theme='icon-standardsecondary'
              >
                <HelpIcon />
              </Button>
            </ExternalUrl>
          </NavigationItem>,
          <ProfileMenu key='ProfileMenu' />
        ]}
      />
    )
  }
}

export default connect()(DashboardHeader)



// WEBPACK FOOTER //
// ./src/components/dashboard/DashboardHeader.js